
import { Options, Vue } from 'vue-class-component';
import Footer from "@/app/ui/components/footer/index.vue";
import Whatsapp from "@/app/ui/components/lp-icon/svgs/whatsapp.vue";
import { AuthController } from '../../controllers/AuthController';
import { FlagsMedusa } from '@/feature-flags/flags-misc-medusa';
import { getDeviceBearer, getPairingCode, getTempUserEmail, removeTempUserEmail } from '@/app/infrastructures/misc/Cookies';
import { STATUS } from './constants';
import { PHONE_NUMBER_HD, sleep } from '@/app/infrastructures/misc/Utils';
import { cleanPhoneNumber } from '@/app/infrastructures/misc/common-library/Whatsapp';

@Options({
  name: "LoginApproval",
  components: {
    Footer,
    Whatsapp
  }
})
export default class LoginApproval extends Vue {
  approvalPhone = ""
  pairingCode =  ""
  username = ""
  status: string = STATUS.PENDING;
  hasDeviceBearer = getDeviceBearer();
  countdown = 25;
  timer: any = null;

  cleanPhoneNumber = cleanPhoneNumber;

  get phoneNumberHD() {
    return PHONE_NUMBER_HD
  }

  get countdownValue() {
    return `${Math.floor(this.countdown / 60).toString().padStart(2, '0')}:${
          (this.countdown % 60).toString().padStart(2, '0')}`
  }
  signal = new AbortController();
  async sendDeviceAuthCheckApproval() {
    await AuthController.sendDeviceAuthCheckApproval()
    .then((res) => {
      if (res.status === STATUS.EXPIRED) {
        this.$router.push("/");
        return;
      }
      this.status = res.status;
      if (res.status === STATUS.REJECTED) {
        this.approvalPhone = res.masterPhoneNumber;
      }
    })
    .catch((error) => {
      if (error.response && error.response.status === 403) {
        this.$router.push("/");
      }
    })
  }
  async manualCheck() {
    this.checkApproval();
    this.setCountdown();
  }
  async autoApprovalDelay() {
    await sleep(FlagsMedusa.config_device_auth_auto_approval_delay.getValue())
    this.checkApproval()
  }
  async checkApproval() {
    if (!this.hasDeviceBearer) return;
    await this.sendDeviceAuthCheckApproval();
    if(this.status === STATUS.PENDING) {
      setTimeout(() => {
        if (this.signal.signal.aborted) return;
        this.checkApproval();
      }, FlagsMedusa.config_device_auth_pooling_rate.getValue());
    }
  }
  get isPending() {
    return this.status === STATUS.PENDING || this.status === STATUS.APPROVED;
  }
  get isRejected() {
    return this.status === STATUS.REJECTED;
  }
  get userAgent() {
    return window.navigator.userAgent
  }
  goBack() {
    this.$router.replace("/");
  }
  setCountdown() {
    this.countdown = 25;
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      if(this.countdown <= 0) {
        clearInterval(this.timer);
        this.countdown = 0
        return;
      }
      this.countdown = this.countdown - 1;
    }, 1000);
  }
  created() {
    this.status = this.$route.meta?.status as any || STATUS.PENDING;
    this.pairingCode = getPairingCode()
    this.username = getTempUserEmail()
    if (this.status !== STATUS.NOT_ALLOWED && !this.hasDeviceBearer) {
      this.$router.push("/");
    }
  }
  mounted() {
    if (this.status !== STATUS.NOT_ALLOWED) {
      this.autoApprovalDelay()
      this.setCountdown();
    }
  }
  unmounted() {
    this.signal.abort()
  }
}
